import { useActiveOrg } from '../contexts/ActiveOrgContext'
import { OrgMembersPanel } from '../components/OrgMembersPanel'

/**
 * Standalone members page at `/users`.
 * Shows the same members table as the Members tab in OrganizationDetailPage,
 * scoped to the currently active organization.
 */
export function OrgMembersPage() {
  const { activeOrgId, activeOrgCapabilities } = useActiveOrg()

  if (!activeOrgId) {
    return (
      <div className="mx-auto max-w-5xl px-4 py-6 md:px-6 md:py-8">
        <p className="text-pax-gray text-sm">No active organization selected.</p>
      </div>
    )
  }

  return (
    <div className="mx-auto max-w-5xl px-4 py-6 md:px-6 md:py-8">
      <OrgMembersPanel orgId={activeOrgId} isOwner={activeOrgCapabilities.canUpdateOrg} />
    </div>
  )
}
